import { Component, OnInit, ViewChild, ElementRef, Input, OnDestroy, OnChanges, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Chart } from '../../lib/chart.bundle.min.js';

@Component({
  selector: 'ed-bar-chart',
  templateUrl: './ed-bar-chart.component.html',
  styleUrls: ['./ed-bar-chart.component.scss']
})
export class EdBarChartComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  unsubscribe$ = new Subject<any>();

  @ViewChild('canvas')
  canvasRef: ElementRef;

  @Input()
  data: any;

  @Input()
  height = "300px";

  @Input()
  labelX = "";

  @Input()
  labelY = "";

  @Output('pointClicked')
  pointClicked = new EventEmitter<any>();

  _chart: Chart;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.canvasRef.nativeElement.onclick = e => {
      if (!this._chart) return;
      var activePoints = this._chart.getElementsAtEvent(e);
      console.log(activePoints);
      if (activePoints.length == 0) return;
      var index = activePoints[0]._index;
      var datasetIndex = activePoints[0]._datasetIndex;
      var point = this.data[datasetIndex].data[index];
      console.log(point);

      var args = {
        datasetIndex: datasetIndex,
        pointIndex: index,
        point: point
      };

      this.pointClicked.emit(args);

      // => activePoints is an array of points on the canvas that are at the same position as the click event.
    };
  }


  ngOnDestroy() {
    this.unsubscribe$.next();
  }

  ngOnChanges() {
    this.renderChart();
  }

  renderChart() {

    if (!this.data) return;

    var ctx = this.canvasRef.nativeElement.getContext('2d');

    var options: any = {
      maintainAspectRatio: false,
      responsive: true,
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

    console.log('creating chart object');

    if (this._chart) this._chart.destroy();

    this._chart = new Chart(ctx, {
      type: 'bar',
      data: this.data,
      options: options
    });
  }


}


